module.exports = __webpack_public_path__ + "img/Moray.c14fc0a0.png";